import React from 'react';
import { useNavigate } from 'react-router-dom';
import RadioInput from '../../components/RadioButton';
import Button from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../core/app_state_config';
import './patient-age-range.scss';
import { updatePersonalForm } from '../../core/actions';

const PatientAgeRange: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const first_name = useSelector((state: RootState) => state.app).personal_form.first_name;
    const [patientAgeValue, setPatientAgeValue] = React.useState<any>(null);

    function onChanged(value: any) {
        setPatientAgeValue(value);
    }

    function onSubmitted() {
        dispatch(updatePersonalForm('patient_age_range', patientAgeValue));
        navigate('/onboarding', { replace: true });
    }

    return (
        <div className="patient-age-range">
            <h1 className="patient-age-range__title">{`What is the age of ${first_name}?`}</h1>
            <RadioInput id={'eighteen_years_or_older'} label={'18 years or older'} groupValue={patientAgeValue} onChange={onChanged} value={'eighteen_years_or_older'} />
            <RadioInput id={'between_thirteen_and_seventeen_years_old'} label={'Between 13 and 17 years old'} groupValue={patientAgeValue} onChange={onChanged} value={'between_thirteen_and_seventeen_years_old'} />
            <RadioInput id={'less_than_thirteen_years_old'} label={'Less than 13 years old'} groupValue={patientAgeValue} onChange={onChanged} value={'less_than_thirteen_years_old'} />
            <div style={{ marginTop: 16 }}>
                <Button type='primary' onPressed={onSubmitted} disabled={!patientAgeValue}>
                    {'Submit'}
                </Button>
            </div>
        </div>
    );
}

export default PatientAgeRange;
